import { createAction } from '@reduxjs/toolkit';
import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from "../../utils/redux/getConstantsByFeatureName";
import getActionCreators from "../../utils/redux/getActionCreators";
import getActionHandlers from "../../utils/redux/getActionHandlers";
import getSelectorByFeatureName from "../../utils/redux/getSelectorByFeatureName";
import { initialState as baseInitState } from "../../utils/redux/commonActionHandlers";

const baseConstants = getConstantsByFeatureName("VESSELS");
export const selector = getSelectorByFeatureName("vessels");

export const constants = {
  ...baseConstants,
  SET_ITEM: `@VESSELS/SET_ITEM`,
  SET_FILTER: `@VESSELS/SET_FILTER`,
  ADD_IMOS_TO_PARSE: `@VESSELS/ADD_IMOS_TO_PARSE`,
};

const baseActions = getActionCreators(constants);

export const actionHandlers = getActionHandlers(constants);

export const actions = {
  ...baseActions,
  setItem: createAction(constants.SET_ITEM),
  setFilter: createAction(constants.SET_FILTER),
  addImosToParse: createAction(constants.ADD_IMOS_TO_PARSE),
};

const initialState = {
  ...baseInitState,
  item: null,
  // CREW-1024: the filter is whatever the URL says, and an empty one is a
  // clean /vessels. The old defaults went with the popup: `is_managed: All`
  // meant the same as "absent", and `group` / `company` / `is_active` were
  // read by nothing.
  // The search box is part of the filter and lives in the URL with it. It was
  // seeded from localStorage, which made a shared link mean something different
  // for every reader — see utils/redux/urlFilterSagas.
  search: "",
};

export const reducer = buildReducer(initialState, {
    ...actionHandlers,
    // CREW-1024: replace the whole filter with what the URL says — draft and
    // applied in one step, since the URL is already the applied state — and
    // reset paging, because page 4 of the old filter means nothing here.
    [constants.SET_FILTER]: (state, { payload }) => ({
      ...state,
      filter: payload,
      appliedFilter: payload,
      pagination: {
        ...state.pagination,
        current: 1,
      },
    }),
    // QA 2026-05-22: clear `isLoading` / `isPushing` on top of
    // assigning `item`. The vessels saga dispatches `setItem`
    // (custom action) instead of the standard `ADD_LOADED_ITEM`
    // path that `commonActionHandlers.setItemAsData` resets, so
    // a `LOAD_ITEM_REQUEST` → `setItem` round-trip used to wedge
    // `isLoading: true`. That kept the NavigationBar's
    // `LinearProgress` glued to the top of `/vessels/:id/edit`
    // forever — visible whenever the form is opened via SPA
    // navigation (where `fetchItemsPageInit` doesn't run, so
    // the offsetting list-load reset never fires).
    [constants.SET_ITEM]: (state, { payload: item }) => ({
      ...state,
      item,
      isLoading: false,
      isPushing: false,
    }),
  });
